import React from "react";
import { useStateContext } from "../../../context/ContextProvider";
import useFadeInOnScroll from "../../../components/Effects/FadeInOnScroll";

import img1 from "../../../assets/images/services/1-1.jpg";
import img2 from "../../../assets/images/services/1-2.png";
import img3 from "../../../assets/images/services/1-3.png";

const DoDealCRM = () => {

    const {
        isMobile
    } = useStateContext();

    useFadeInOnScroll();

    const cards = [
        {
            title: "Visualize your sales funnel with customizable dashboards.",
            image: img1,
        },
        {
            title: "Assign tasks automatically to ensure no opportunity slips through the cracks",
            image: img2,
        },
        {
            title: "Monitor performance metrics in real-time to identify areas for improvement",
            image: img3,
        }
    ];


    const prolist = [
        {
            text: "Simplified Lead Management",
            active: false
        },
        {
            text: "Streamlined Sales Processes",
            active: true
        },
        {
            text: "Team Collaboration Made Easy",
            active: false
        },
        {
            text: "Automation for Efficiency",
            active: false
        },
        {
            text: "Integration with WhatsApp",
            active: false
        },
        {
            text: "Affordable Pricing Plans",
            active: false
        },
    ];
    return (
        <>
            <div className="w-full relative py-5 my-5 flex flex-col gap-5">
                <div className="h-[50px]"></div>
                {/* 1 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-1">
                    <div className="fade-element text:4xl md:text-5xl lg:text-6xl capitalize font-bold">
                        DODEAL CRM: Your ultimate solution for Business growth
                    </div>
                    <div className="w-full flex justify-end">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            In today’s competitive market, managing customer relationships effectively is key to success. At DO DEAL, we offer a comprehensive CRM system designed specifically for small businesses, startups, and real estate professionals. Our platform simplifies sales processes, streamlines team collaboration, and enhances productivity all while keeping costs low.
                        </div>
                    </div>
                </div>
                {/* 2 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        Why choose DODEAL CRM?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            DO DEAL CRM is more than just software; it’s a powerful tool that helps you organize leads, manage clients, and automate workflows effortlessly. Whether you’re a small business owner, a sales representative, or a real estate agent, our CRM provides everything you need to grow your business efficiently.
                        </div>
                    </div>
                </div>
                {/* 3 */}
                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {prolist?.map((list, index) => (
                            <div
                                key={index}
                                className={`fade-element w-full border capitalize rounded-full font-bold p-3 ${list?.active && "bg-white text-black"}`}
                            >
                                {list?.text}
                            </div>
                        ))}
                        <div className="fade-element col-span-2 flex h-full items-center justify-center text-justify text-[var(--l-gray)] px-3">
                            Our platform offers an intuitive interface that makes managing your sales pipeline easier than ever.
                        </div>
                    </div>
                </div>
                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {cards?.map((card, index) => (
                            <div
                                key={index}
                                className={`fade-element relative w-full h-[350px] border border-[5px] rounded-[30px] capitalize overflow-hidden flex flex-col justify-end`}
                                style={{
                                    backgroundImage: `url("${card?.image}")`, backgroundSize: "cover", backgroundPosition: "center"
                                }}
                            >
                                <div className="absolute w-full h-full rounded-[30px]" style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #000000 100%)", mixBlendMode: "multiply" }}></div>
                                <div className="absolute w-full h-full rounded-[30px] flex flex-col p-4 justify-end" style={{ zIndex: 1 }}>
                                    <div className="font-bold capitalize">{card?.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* 4 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4 text-base">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        Key Features of DODEAL CRM
                    </div>
                    <div className="fade-element flex gap-2">
                        <div className="!w-[30px] text-end">1.</div>
                        <div>
                            Centralized contact management for easy access to client information.
                        </div>
                    </div>
                    <div className="fade-element flex gap-2">
                        <div className="!w-[30px] text-end">2.</div>
                        <div>
                            Pipeline visualization to monitor sales progress at a glance.
                        </div>
                    </div>
                    <div className="fade-element flex gap-2">
                        <div className="!w-[30px] text-end">3.</div>
                        <div>
                            Automated workflows for task assignments, reminders, and notifications.
                        </div>
                    </div>
                    <div className="fade-element flex gap-2">
                        <div className="!w-[30px] text-end">4.</div>
                        <div>
                            Secure storage for contracts, agreements, and other important documents.
                        </div>
                    </div>
                    <div className="fade-element flex gap-2">
                        <div className="!w-[30px] text-end">5.</div>
                        <div>
                            Real-time reporting and analytics to measure success and adjust strategies accordingly.
                        </div>
                    </div>
                </div>
                {/* 5 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-end">
                        Join Thousands of Satisfied Users
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            At DO DEAL, we pride ourselves on delivering exceptional value through innovative technology and unmatched support. Our user-friendly interface ensures quick adoption, while robust features empower you to achieve your goals efficiently.
                        </div>
                    </div>
                </div>
                {/* 6 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-start">
                        Ready to take your business to the next level?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Contact us to learn how DO DEAL CRM can transform the way you manage relationships, streamline processes, and drive growth!
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DoDealCRM;